export const STAFF_LIST = `
  query staffs(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: StaffOrderInput
    $filter: StaffFilterInput
    $searchText: String
  ) {
    staffs(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Staff {
        id
        contact_id
        is_active
        its
        dts
        contact {
          id
          firstname
          lastname
          email
          phone
          mobile
          its
          user {
            id
            email
            active
          }
          staff {
            id
            contact_id
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_STAFF = `
  query getStaff($id: Int!, $tenant_id: Int!) {
    getStaff(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Staff {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
          phone
          mobile
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CONTACTS_FOR_STAFF = `
  query contactsForStaff(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $searchText: String
  ) {
    contacts(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      searchText: $searchText
    ) {
      __typename
      ... on Member {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
